const ErrorSymbol = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2457_4948)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.9974 2.0013C4.68369 2.0013 1.9974 4.68759 1.9974 8.0013C1.9974 11.315 4.68369 14.0013 7.9974 14.0013C11.3111 14.0013 13.9974 11.315 13.9974 8.0013C13.9974 4.68759 11.3111 2.0013 7.9974 2.0013ZM0.664062 8.0013C0.664062 3.95121 3.94731 0.667969 7.9974 0.667969C12.0475 0.667969 15.3307 3.95121 15.3307 8.0013C15.3307 12.0514 12.0475 15.3346 7.9974 15.3346C3.94731 15.3346 0.664062 12.0514 0.664062 8.0013Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.9974 4.66797C8.36559 4.66797 8.66406 4.96645 8.66406 5.33464V8.0013C8.66406 8.36949 8.36559 8.66797 7.9974 8.66797C7.62921 8.66797 7.33073 8.36949 7.33073 8.0013V5.33464C7.33073 4.96645 7.62921 4.66797 7.9974 4.66797Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.33073 10.668C7.33073 10.2998 7.62921 10.0013 7.9974 10.0013H8.00406C8.37225 10.0013 8.67073 10.2998 8.67073 10.668C8.67073 11.0362 8.37225 11.3346 8.00406 11.3346H7.9974C7.62921 11.3346 7.33073 11.0362 7.33073 10.668Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2457_4948">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ErrorSymbol;
